export const GET_VIRTUALS_GAMES = '/sportsbook-req/getVirtualGamesList';
export const GET_IFRAME_DATA = '/sportsbook-req/getDataForIframe';
export const VIRTUALS_WIDGET_CLASS = 'virtuals-widget';
export const VIRTUALS_IFRAME_CONTAINER = `${VIRTUALS_WIDGET_CLASS}__container`;
export const VIRTUALS_IFRAME = `${VIRTUALS_IFRAME_CONTAINER}--iframe`;

export const VIRTUAL_FOOTBALL_SLUG = 'virtual-football';
export const VIRTUAL_GOLF_SLUG = 'virtual-golf';
export const VIRTUAL_TENNIS_SLUG = 'virtual-tennis';
export const VIRTUAL_GREYHOUNDS_SLUG = 'instant-greyhounds';
export const VIRTUAL_HORSE_RACING_SLUG = 'instant-horses';
export const VIRTUAL_TROTTING_SLUG = 'instant-trotting';
export const VIRTUAL_BASKETBALL_SLUG = 'euroleague-legends';
import { HORSE_RACING_SLUG, GREYHOUND_RACING_SLUG, TROTTING_SLUG } from '~shared/utils/sportsbook';
export const VIRTUAL_GENERIC_SLUG_MAPPINGS = {
    tennis: VIRTUAL_TENNIS_SLUG,
    basketball: VIRTUAL_BASKETBALL_SLUG,
    [GREYHOUND_RACING_SLUG]: VIRTUAL_GREYHOUNDS_SLUG,
    [HORSE_RACING_SLUG]: VIRTUAL_HORSE_RACING_SLUG,
    [TROTTING_SLUG]: VIRTUAL_TROTTING_SLUG,
};

export const I18N_PREFIX = 'virtuals';
export const VIRTUALS_LOGIN_TEXT = `${I18N_PREFIX}.login`;
export const VIRTUALS_LOGIN_TO_SEE_TEXT = `${I18N_PREFIX}.login_to_see`;
export const VIRTUALS_VIRTUAL_SPORTS = `${I18N_PREFIX}.virtual_sports`;
export const VIRTUALS_VIRTUAL_SPORTS_SLUG = 'url.inplay_virtuals';
export const VIRTUALS_LIVE_NOW = `${I18N_PREFIX}.live_now`;
export const VIRTUALS_RACING = `${I18N_PREFIX}.races_every_3_mins`;
export const RACING = 'virtual-racing';
export const VIRTUAL = 'virtual';
export const INSTANT = 'instant';

export const GTM_VIRTUALS_PAGE_BASE = 'virtual-sports';
export const GTM_VIRTUALS_PAGE_CAROUSEL = 'tabs';
export const GTM_VIRTUAL_SPORT_LINK_BAR = 'virtual-sports-link';

export const MOBILE_ORIENTATION_CHANGE_THROTTLE = 200; // ms

export const UFC_WRAPPER_CSS_ID = 'uc-spectate-sport-client-view';
